import type {Endpoints} from "@hosttools/web/server/routes/routes.auth.types";
import {useContext, useMemo} from "react";

import {Base} from "../../../services/base";
import {HTTPContext} from "../../contexts";

export function useAuthService() {
    const http = useContext(HTTPContext);
    const base = useMemo(() => new Base<Endpoints>(http), [http]);
    return base;
}
